import React from "react";
import { Container } from "react-bootstrap";
import Service from "./Service";
import HeroSection from "./HeroSection";

const Services = () => {
  return (
    <>
    <HeroSection/>
    <section id="services" className="services-section">
      <Container>
        <div className="services-content">
        <h2 className="services-heading text-center p-3">Our Services</h2>
          <p className="services-text text-center ">
            <strong>Bhanot International LLC</strong> is a global leader in sourcing, refurbishing, and distributing mobile devices across international markets. We specialize in asset recovery and the redistribution of wireless products, serving over <strong>20,000 global customers</strong>.  Bhanot International LLC collaborates with <strong>manufacturers, carriers, and retail partners</strong>, offering tailored solutions for <strong>current, end-of-life (EOL), overstocked, and returned mobile inventory</strong>. Our expertise spans <strong>inventory management, logistics, distribution services, supply chain fulfillment, and sustainable recycling</strong>, ensuring efficient and responsible handling of mobile products worldwide.
          </p>
        </div>
      </Container>
    </section>
    <Service/>
    </>
  );
};

export default Services;